export default function useIsProduction() {
    const isProduction = process.env.NEXT_PUBLIC_ENV_VARIABLE !== 'development';
    return isProduction;
}
